// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 764) return "static/chunks/764.eb7ca617a0a12bd7.js";
	if (chunkId === 306) return "static/chunks/306.66466a00c09ddf50.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"22":"8cbe08c9894df25a","776":"8368583aeb607814","812":"14bc97d1c30cd567","939":"163c022470a9e51a"}[chunkId] + ".js";
};